import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { App, AlertController, NavParams } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { Logs, Projects } from 'api/collections';
import { Log } from 'api/models';
import { Events } from 'ionic-angular/util/events';

import { LogUsersPage } from '../log-users/log-users';
import { LogMessagesPage } from '../log-messages/log-messages';
import { LogPhotosPage } from '../log-photos/log-photos';
import { LogActivityDetailsPage } from '../log-activity-details/log-activity-details';
import { ISDEV, APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';

import * as permissions from '../../services/permissions';
import { AuthenticationService } from '../../services/congito';
@Component({
  templateUrl: 'log-view.html'
})
export class LogView implements OnInit {
  log: Log;
  logId: string;
  tabParams: Object;
  logMessagesPage = LogMessagesPage;
  logUsersPage = LogUsersPage;
  logPhotosPage = LogPhotosPage;
  logActivityDetailsPage = LogActivityDetailsPage;
  canRemoveLog = false;
  public isDev = ISDEV;
  public project: any;

  constructor(
    private _app: App,
    public navParams: NavParams,
    public appCtrl: App,
    private alertCtrl: AlertController,
    private events: Events,
    public httpService: HttpService,
    public authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.tabParams = {
      logId: navParams.get('logId'),
    };
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit() {
    if(this.isDev == true) { console.log('log view page') }
    const logId = <string>this.navParams.get('logId');
    MeteorObservable.autorun().subscribe(() => {
      // MeteorObservable.subscribe('logDetails', logId).subscribe();
      this.httpService.MeteorSubscribe('logDetails', logId);
      this.log = Logs.findOne(logId);

      const viewer = this.authenticationService.MeteorUser();
      if (this.log) {
        const project = Projects.findOne(this.log.projectId);
        const isProjectManager = permissions.isProjectManager(project, viewer);
        const isLogCreator = viewer._id === this.log.creatorId;
        this.canRemoveLog = isProjectManager || isLogCreator;

        this.project = project;

        // Concatenate the string 'activityLogDetails-' with the LogID
        const displayString: string = "activityLogDetails-" + this.log._id;
        
        this.router.navigate([project.name, displayString]);
      }
    });
    
  }

  ngOnDestroy() {
    this.router.navigate([this.project.name, 'logs']);
  }

  removeLog(): void {
    if (!this.log) {
      return;
    }

    const alert = this.alertCtrl.create({
      title: 'Confirm',
      message: `Are you sure you would like to remove this log?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            /*
            MeteorObservable.call('removeLog', this.log._id).subscribe({
              next: () => {
                this.events.publish('rootNavPop');
              },
            });
            */
            this.httpService.MeteorCall('removeLog', this.log._id)
              .then(() => {
                this.events.publish('rootNavPop');
              })
              .catch(err => {
                console.log('meteor call error:', err);
              });
            alert.dismiss();
            return false;
          }
        }
      ]
    });

    alert.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/log-view/log-view.ts